module.exports = __webpack_public_path__ + "img/body-care-1.615d55a.webp";